import { PageHead } from "../ui/kit";
import { useTexts } from "../texts";
import { ModelsGrid } from "./ModelsGrid";
import { useTitle } from "./parts";
import { MobileActions } from "./widgets";

/**
 * IA › Modelos (§5.9 `ia-modelos`): el encabezado con «Modelo manual» y la grilla de modelos compartida con la ficha del
 * proveedor (`ModelsGrid`: buscador, Usables · Todos, «Más filtros», tabla C28 paginada y ordenada en el servidor; en el
 * celular, lista C17).
 */
export function ModelsPage() {
  const { L } = useTexts();
  useTitle(L("ADM_AI_MODELS"));
  return (
    <>
      <PageHead title={L("ADM_AI_MODELS")} sub={L("ADM_AI_MODELS_SUB")}>
        <a className="tm-btn primary" href="/Ai/Avanzado/Manual">
          {L("ADM_AI_MANUAL_TITLE")}
        </a>
      </PageHead>
      <ModelsGrid />
      <MobileActions>
        <a className="tm-btn primary" href="/Ai/Avanzado/Manual">
          {L("ADM_AI_MANUAL_TITLE")}
        </a>
      </MobileActions>
    </>
  );
}
